export class AccountCardFetchError extends Error {
	readonly status: number;

	constructor(message: string, status: number) {
		super(message);
		this.name = "AccountCardFetchError";
		this.status = status;
	}
}
